import React, { useState } from 'react';
import api from '../services/api';

export default function ResetPassword({ onBackToLogin }) {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token') || '';

  const [password, setPassword]   = useState('');
  const [confirm, setConfirm]     = useState('');
  const [error, setError]         = useState('');
  const [loading, setLoading]     = useState(false);
  const [success, setSuccess]     = useState(false);

  if (!token) {
    return (
      <div className="auth-page">
        <div className="auth-wrap">
          <div className="auth-card" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 36, marginBottom: 12 }}>⚠️</div>
            <p style={{ color: '#ffffff', fontWeight: 700, fontSize: 15, margin: '0 0 8px' }}>Invalid reset link</p>
            <p style={{ color: '#94a3b8', fontSize: 13, margin: '0 0 20px' }}>
              This link is missing a reset token. Please request a new one.
            </p>
            <button
              onClick={onBackToLogin}
              style={{ background: 'none', border: 'none', color: '#7c3aed', fontSize: 13, cursor: 'pointer', textDecoration: 'underline' }}
            >
              Back to Sign In
            </button>
          </div>
        </div>
      </div>
    );
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    setLoading(true);
    try {
      await api.resetPassword(token, password);
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-wrap">
        <div className="auth-card">

          {/* Brand */}
          <div className="auth-brand">
            <div className="auth-brand-icon">🎬</div>
            <h1>Cinema<span> Alert</span></h1>
            <p>
              {success ? 'Your password has been reset.' : 'Choose a new password for your account.'}
            </p>
          </div>

          {success ? (
            <div style={{ textAlign: 'center', padding: '8px 0 16px' }}>
              <div style={{ fontSize: 36, marginBottom: 12 }}>✅</div>
              <p style={{ color: '#ffffff', fontWeight: 700, fontSize: 15, margin: '0 0 8px' }}>Password updated!</p>
              <p style={{ color: '#94a3b8', fontSize: 13, margin: '0 0 20px' }}>
                You can now sign in with your new password.
              </p>
              <button
                onClick={onBackToLogin}
                className="btn btn-primary"
                style={{ padding: '10px 28px', fontSize: 14 }}
              >
                Sign In
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">New Password</label>
                <input
                  className="form-input"
                  type="password"
                  placeholder="At least 6 characters"
                  value={password}
                  onChange={e => { setPassword(e.target.value); setError(''); }}
                  required
                  autoFocus
                />
              </div>
              <div className="form-group">
                <label className="form-label">Confirm Password</label>
                <input
                  className="form-input"
                  type="password"
                  placeholder="Repeat your new password"
                  value={confirm}
                  onChange={e => { setConfirm(e.target.value); setError(''); }}
                  required
                />
              </div>

              {error && <div className="form-error">{error}</div>}

              <button
                type="submit"
                className="btn btn-primary"
                style={{ width: '100%', marginTop: 6, padding: '10px', fontSize: 14, borderRadius: 'var(--r)' }}
                disabled={loading}
              >
                {loading ? 'Please wait…' : 'Reset Password'}
              </button>
            </form>
          )}

          {!success && (
            <div className="auth-toggle">
              Remember your password?{' '}
              <button onClick={onBackToLogin}>Sign in</button>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
